import { createSlice } from '@reduxjs/toolkit';

import jwtDecode from 'jwt-decode';

const initialState = {
    user: {},
    token: "",
    isAuthenticate: false, // default value
    roles: []
};

export const auth = createSlice({
    name: 'auth',
    initialState,

    reducers: {
        // authentification
        loginUser(state, action) {
            // reset data
            state.user = null;
            state.token = "";
            state.isAuthenticate = false;
            state.roles = [];
            const loginRequest = action.payload;
            state.user = loginRequest.userDTO;
            state.token = loginRequest.accessToken;
            
            state.isAuthenticate = true;
            //console.log(state.isAuthenticate)

            //let item = loginRequest.roles.map((role,index) => { return role.libelle;  })

            //state.roles = item;
            // redirect to dashboard
        },

        // authentification
        resetAuthData(state) {
            state.user = null;
            state.token = '';
            state.isAuthenticate = false;
            state.roles = [];
        },

        // authentification
        checkAuthenticate(state) {
            //console.log(action);
            let statut = false;
            if (state.token) {
                const decodedToken = jwtDecode(state.token);
                const currentDate = new Date().getTime() / 1000; // Convertir la date actuelle en secondes
                if (decodedToken.exp < currentDate) {
                    // Le token a expiré
                    statut = false;
                }else{
                    statut = true
                }
            }

            state.isAuthenticate = statut;

            if (!statut) {
                state.user = null;
                state.token = "";
                state.isAuthenticate = false;
                state.roles = [];
            }

            // redirect to dashboard
        }
    },
});

export const {
    loginUser,
    checkAuthenticate,
    resetAuthData
} = auth.actions;

export default auth.reducer;